import './Dyno.css';
import RightArrow from '../../images/right-arrow.svg';
import DivyFeature from '../../images/numo-feature.png';
import NumoFeatureVisual from './NumoFeatureVisual';

const Numo = () => {
  return (
    <div className="dyno-container" id="numo-section">
      <div className="dyno-columns">
        <div className="dyno-left-column">
          <div className="dyno-row">
            <span className="dyno-text">Numo</span>
            <span className="dyno-description"> allows decimal percentage discount values on your discounts. Break away from Shopify's auto rounding.</span>
          </div>
          <div className="dyno-second-row">
            <span className="dyno-text-secondary">Shopify's auto rounding can be a pain. We've got you covered.</span>
            <button className="dyno-button" onClick={() => {
              window.open('https://apps.shopify.com/decimal-percentage-discounts', '_blank');
            }}>
              <div className="dyno-button-text">Get started</div>
              <img src={RightArrow} alt="right arrow" className="arrow-icon" />
            </button>
          </div>
        </div>
        <div className="dyno-right-column">
          <NumoFeatureVisual />
        </div>
      </div>
    </div>
  );
};

export default Numo;